import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import user from './user';
import application from './application';
import quote from './quote';
import settlement from './settlement';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: 'ecx.saigon-settlement-vuex',
  storage: window.localStorage,
  reducer: (state) => ({
    // Add fields that should be persisted
  })
});
export default new Vuex.Store({
  modules: {
    user,
    application,
    quote,
    settlement
  },
  plugins: [vuexLocal.plugin]
});
